"use client"

import { AuthService } from '@repo/ui/lib/api/services/auth.service';
import { safeSetItem } from '@repo/ui/lib/utils/localStorage';
import { useMutation } from '@tanstack/react-query';

export type DemoInput = {
  email: string;
  nom?: string;
  prenom?: string;
  planType?: 'BASIC' | 'ADVANCED';
  password?: string;
  tierId?: string;
};

export function useRequestDemo() {
  return useMutation({
    mutationFn: async (input: DemoInput) => {
      const auth = new AuthService();
      const res = await auth.demo(input);
      return res.data;
    },
    onSuccess: (data: any) => {
      // Persist token and optionally user
      if (data?.data?.token) {
        safeSetItem('token', data.data.token);
      }
    }
  });
}


